import React, { useEffect, useState } from 'react';
import { Collapse, Icon } from 'antd';
import { Button, ColumnProps, Row, Table, Widget } from '@digital/ui';
import { ordemCompraIdState, reloadState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { getContratoSasHistoricoExpectativaCompraTotvs } from '@app/api/sas/ordemCompra';


interface Props {
    parteDoFluxo?: boolean;
}

export const WidgetInfoAprovacaoExpectativaTotvs = ({ parteDoFluxo = false }: Props) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);

    const [historicoAprovacoes, setHistoricoAprovacoes] = useState<any[]>([]);

    useEffect(() => {
        getContratoSasHistoricoExpectativaCompraTotvs(ordemCompraId)
            .then(data => {
                if (isObjNotEmpty(data)) {
                    setHistoricoAprovacoes(data || []);
                }
            });
    }, [ordemCompraId]);

    const handleAtualizar = () => {
        getContratoSasHistoricoExpectativaCompraTotvs(ordemCompraId, true)
            .then(data => {
                if (isObjNotEmpty(data)) {
                    setHistoricoAprovacoes(data || []);
                }
            });
    };

    const columnsInfoAprovacao: ColumnProps<any>[] = [
        {
            title: 'Aprovador',
            dataIndex: 'aprovador',
        },
        {
            title: 'Aprovador Alternativo',
            dataIndex: 'aprovadorAlternativo',
        },
        {
            title: 'Data Geração',
            dataIndex: 'dataGeracaoString',
        },
        {
            title: 'Data Aprovação',
            dataIndex: 'dataAprovacaoString',
        },
        {
            title: 'Situação',
            dataIndex: 'situacao',
        },
        {
            title: 'Rejeição',
            dataIndex: 'rejeicao',
        },
    ];

    return (
        <Collapse
            bordered={false}
            defaultActiveKey="WidgetInfoAprovacaoExpectativaTotvs"
            expandIcon={() => <Icon type="arrows-right_4" />}>
            <Collapse.Panel
                header="Informações de Aprovação da Expectativa de Compra no Totvs"
                key="WidgetInfoAprovacaoExpectativaTotvs"
                showArrow={!parteDoFluxo}>
                <Widget
                    actions={[
                        <Button
                            onClick={() => handleAtualizar()}
                            type="primary"
                            key="gerarContratoBtn"
                            style={{ marginLeft: 10 }}>
                            Atualizar
                        </Button>
                    ]}
                >
                    <Row>
                        <Table
                            style={{ paddingInline: '4px' }}
                            columns={columnsInfoAprovacao}
                            dataSource={historicoAprovacoes}
                            pagination={false}
                        />
                    </Row>
                </Widget>
            </Collapse.Panel>
        </Collapse>
    );
};